import React from "react";
import { Link } from "react-router-dom";
import { GraduationCap, Inbox } from "lucide-react";

export function DashboardLoading() {
  return (
    <div className="flex min-h-[50vh] items-center justify-center">
      <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-t-2 border-blue-500" />
    </div>
  );
}

export function DashboardNotice({ title = "Couldn't load this page", message }) {
  return (
    <div className="mx-auto w-full max-w-lg px-4 py-10">
      <div className="dash-card rounded-2xl border border-gray-700/50 bg-gray-800/50 px-6 py-10 text-center">
        <p className="text-lg font-semibold text-white">{title}</p>
        <p className="mt-2 text-sm text-gray-400">{message}</p>
      </div>
    </div>
  );
}

export function EmptyState({ icon: Icon = Inbox, title, description, children }) {
  return (
    <div className="dash-card rounded-2xl border border-gray-700/50 bg-gray-800/50 px-6 py-12 text-center">
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-blue-500/20 text-blue-400">
        <Icon className="text-2xl" size={26} />
      </div>
      <p className="text-lg font-semibold text-white">{title}</p>
      {description && <p className="mx-auto mt-2 max-w-md text-sm text-gray-400">{description}</p>}
      {children}
    </div>
  );
}

export function NoCourse({ description = "You're not enrolled in a course yet. Your materials will show up here once you are." }) {
  return (
    <div className="mx-auto w-full max-w-lg px-4 py-10">
      <EmptyState icon={GraduationCap} title="No course yet" description={description}>
        <Link
          to="/complete-registration"
          className="mt-6 inline-flex rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
        >
          Complete registration
        </Link>
      </EmptyState>
    </div>
  );
}
